import React from "react";
import { HelpDot } from "../AgenticGlossary";

/**
 * CustomTab — Settings → Custom: the same backdoor as the header's Custom
 * menu, so everything a member builds is reachable from both directions
 * (Brad, 2026-09-15: "just so everything goes both ways"). One card per
 * custom surface; add a card here when a new custom thing ships.
 */
const CustomTab = ({ onOpenDashboards, onGoToTab, dashboardsEnabled = true, customToolsEnabled = true }) => {
  const cards = [
    dashboardsEnabled && { id: "dashboards", icon: "📊", title: "Dashboards", body: "Widgets and reports built from your own data. Build one with the guided wizard or ask Ollie.", cta: "Open dashboards", onClick: onOpenDashboards },
    { id: "skills", icon: "🧰", title: "Skills", body: "Your playbooks: build them with the wizard or Ollie, share them with your team, run them with /slug.", cta: "Go to Skills", onClick: () => onGoToTab("skills") },
    { id: "connections", icon: "🔌", title: "Connections", body: "The accounts your agents can act on: Google, GitHub, Canva, your CRM and more.", cta: "Go to Integrations", onClick: () => onGoToTab("integrations") },
    customToolsEnabled && { id: "tools", icon: "🛠️", title: "Custom tools", body: "Tools built for you from any API (Custom MCPs) — Ollie can use them the moment they're live.", cta: "Go to Custom Tools", onClick: () => onGoToTab("integrations", "custom-tools") },
  ].filter(Boolean);
  return (
    <div data-testid="settings-custom-tab">
      <div className="setting-group" style={{ marginBottom: 20 }}>
        <h3>🛠️ Custom — everything you've built for yourself<HelpDot term="custom" label="What do Custom, dashboards, connections and tools mean?" /></h3>
        <p style={{ color: "var(--text-secondary)", fontSize: 14, lineHeight: 1.6 }}>
          The same shortcuts as the Custom button in the header. Dashboards, skills, connections and tools are yours; your agents use them on every surface.
        </p>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 12 }}>
        {cards.map((c) => (
          <button key={c.id} type="button" onClick={c.onClick} data-testid={`custom-card-${c.id}`}
            style={{ textAlign: "left", padding: "14px 16px", borderRadius: 12, background: "rgba(255,255,255,0.03)", border: "1px solid var(--border-color, rgba(255,255,255,0.1))", color: "var(--text-primary)", cursor: "pointer" }}>
            <div style={{ fontSize: 22, marginBottom: 6 }}>{c.icon}</div>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{c.title}</div>
            <div style={{ color: "var(--text-secondary)", fontSize: 13, lineHeight: 1.5, marginBottom: 10 }}>{c.body}</div>
            <div style={{ color: "var(--accent-primary, #7c3aed)", fontSize: 13, fontWeight: 600 }}>{c.cta} →</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomTab;
